import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "invasive-toast" }
const _hoisted_2 = { class: "invasive-toast" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ion_icon, {
        icon: _ctx.cloudOfflineOutline,
        class: "icon-space"
      }, null, 8, ["icon"]),
      _cache[0] || (_cache[0] = _createTextVNode(" Nessuna connessione internet ")),
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("small", null, "L'applicazione potrebbe non funzionare correttamente, i dati potrebbero non essere aggiornati.")
      ], -1))
    ], 512), [
      [_vShow, _ctx.isOffline]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ion_icon, {
        icon: _ctx.cloudOfflineOutline,
        class: "icon-space"
      }, null, 8, ["icon"]),
      _cache[3] || (_cache[3] = _createTextVNode(" Impossibile aggiornare le impostazioni ")),
      (_ctx.isOutdated)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[2] || (_cache[2] = [
            _createElementVNode("small", null, "Controlla la tua connessione, quindi chiudi e riapri l'applicazione", -1)
          ])))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, !_ctx.isOffline && _ctx.isOutdated]
    ])
  ]))
}